import { Component, computed, inject, input } from "@angular/core";
import { ShareSalesDto } from "src/models/estate/share-sales.model";
import { ImageCarouselComponent } from "src/app/shared-components/image-carousel/image-carousel.component";
import { ImagePackage } from "src/models/common/image.model";
import { KeyValuePair, KeyValuePairListComponent } from "../key-value-pair-list/key-value-pair-list.component";
import { ConvertUtil } from "src/util/tools/convert.util";
import { RouterLink } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";

@Component({
    selector: "share-sales-detail",
    templateUrl: "./share-sales-detail.component.html",
    styleUrl: "./share-sales-detail.component.scss",
    imports: [ImageCarouselComponent, KeyValuePairListComponent, RouterLink],
})
export class ShareSalesDetailComponent {
    private authService = inject(EvAuthorizationService);

    data = input.required<ShareSalesDto>();
    imagePackages = input<ImagePackage[]>([]);

    protected hasValueAssessmentPermission = toSignal(this.authService.hasPermission(EVServiceType.EvWeb_ValueAssistant));
    protected firstColumnKeyValuePairs = computed<KeyValuePair[]>(() => {
        const info = this.data();
        if (!info) {
            return [];
        }
        const val: KeyValuePair[] = [
            { key: "Registrert", value: ConvertUtil.toDate(info.registeredDate, "-") },
            { key: "Solgt", value: ConvertUtil.toDate(info.soldDate, "-") },
            { key: "Pris", value: info.salesPrice ? ConvertUtil.toNumberWithPostfix(info.salesPrice, "-", "", true) : "-" },
            { key: "Prisantydning", value: info.priceAssumption ? ConvertUtil.toNumberWithPostfix(info.priceAssumption, "-", "", true) : "-" },
            { key: "Fellesgjeld", value: ConvertUtil.toNumberWithPostfix(info.commonDebt, "-", "", true) },
            { key: "m²-pris", value: ConvertUtil.toNumberWithPostfix(info.squareMeterPrice, "-", "", true) },
            { key: "Omsetningshastighet", value: ConvertUtil.toNumberWithPostfix(info.transactionTime, "-", "d", true) },
            { key: "Megler", value: info.estateAgent || "-" },
        ];
        return val;
    });
    protected secondColumnKeyValuePairs = computed<KeyValuePair[]>(() => {
        const info = this.data();
        if (!info) {
            return [];
        }
        const val: KeyValuePair[] = [
            { key: "m²", value: info.residentialMeasuredArea ? ConvertUtil.toNumberWithPostfix(info.residentialMeasuredArea, "-", "m²", true) : "-" },
            { key: "Etasje", value: info.floor || "-" },
            { key: "Soverom", value: info.bedrooms ? info.bedrooms.toString() : "-" },
        ];
        return val;
    });
}
